import { VizRoot } from "features/onboarding/visuals/frame";
import LiveCard from "features/onboarding/visuals/live/LiveCard";
import { VisualMethod, VisualProps } from "features/onboarding/visuals/types";

const METHODS: VisualMethod[] = ["signals", "grid", "dca", "tradingview"];

/** Whether a trading method has a bot illustration (hedging does not). */
export const hasBotVisual = (method: string): method is VisualMethod =>
  (METHODS as string[]).includes(method);

/**
 * A bot type's animated walkthrough illustration: a live chart card that
 * follows the walkthrough's playhead (see `useLiveClock`).
 */
const BotVisual = ({
  method,
  runtime,
}: VisualProps & { method: VisualMethod }) => (
  <VizRoot>
    <LiveCard method={method} runtime={runtime} />
  </VizRoot>
);

export default BotVisual;
